A URL of an external apply form.

When this is provided, SEEK's Apply Form will be disabled and the candidate will be redirected to the supplied URL.
